import { render, staticRenderFns } from "./customer-modal.vue?vue&type=template&id=30db69f4&scoped=true"
import script from "./customer-modal.vue?vue&type=script&lang=js"
export * from "./customer-modal.vue?vue&type=script&lang=js"
import style0 from "./customer-modal.vue?vue&type=style&index=0&id=30db69f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db69f4",
  null
  
)

export default component.exports